import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'time-left-translation',
  templateUrl: './time-left-translation.component.html'
})
export class TimeLeftTranslationComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
